import { v1 } from '@/api/client';

export const fetchCart = () => v1.get<CartDto>('ecom/cart/owner/me');

export const createCart = (cart: CartMutable) =>
  v1.post<CartDto>('ecom/cart', cart);

export const updateCart = (cart: CartMutable) =>
  v1.put<CartDto>('ecom/cart/owner/me', cart);
